import dayjs from 'dayjs';
import { useEffect } from 'react';
import { IoCloseCircle } from 'react-icons/io5';
import LZString from 'lz-string';
import { useNavigate, useParams } from 'react-router-dom';

import { ActiveRecordIcon, check } from "../assets/svg/index.js";

import Spinner from '../Components/CommonComponents/Spinner/index.js';

import { REWARD_LISTING } from '../Routes/RoutesContant.js';
import Dropdown from '../Components/CommonComponents/Dropdown/index.js';

import { isAlphanumeric, isValidEmail, isValidGSTNumber, isValidPhone, isValidString, lastNamevalidation } from './DataValidationUtils.js';

import { fetchLocalStorageItem, setLocalStorageItem } from './StorageUtils.js';
import { FLIGHT_CLASS_CONSTANT, FLIGHT_TRIP_CONSTANT } from './Constant.js';

export const SuccessMessage = ({ message }) => {
	return (
		<>
			{message && (
				<div className="flex mt-2 gap-2 text-sm text-[#09CB11] font-Inter font-medium">
					<img src={check} alt="check" />
					{message}
				</div>
			)}
		</>
	)
}

export const ErrorMesage = ({ error, message }) => {
	return (
		<>
			{error && !message && (
				<div className="flex items-center mt-2 gap-2 text-sm text-red-600 font-Inter font-medium">
					<IoCloseCircle color="#e52424" size={18} />
					{error}
				</div>
			)}
		</>
	)
}

// Utility function to get subdomain information
export const getSubdomainInfo = () => {
	const hostname = window.location.hostname;
	const isLocalhost = hostname.includes("localhost");

	let subdomainName = null;
	let isSubdomain = false;

	// Check for subdomain in development environment
	if (isLocalhost) {
		const parts = hostname.split(".");
		// Assuming pattern subdomain.localhost
		if (parts.length > 1 && parts[0] !== "localhost") {
			subdomainName = parts[0];
			isSubdomain = true;
		}
	} else {
		// Check for subdomain in production environment
		const parts = hostname.split(".");
		// Check if there are more than two parts, indicating a subdomain is present
		if (parts.length > 2) {
			subdomainName = parts[0];
			isSubdomain = true;
		}
		// Check for specific subdomain and main domain
		if (subdomainName === "www") {
			isSubdomain = false; // It's the main domain
			subdomainName = null; // Clear subdomain name
		} else if (subdomainName && subdomainName !== "www") {
			isSubdomain = true; // Any other keyword is a valid subdomain
		}
	}

	return { isSubdomain, subdomainName };
};

// Component to handle main domain redirect
export const MainDomainRedirect = () => {
	const { isSubdomain } = getSubdomainInfo();
	const isMainDomain = !isSubdomain;

	useEffect(() => {
		if (isMainDomain) {
			window.location.href = 'https://www.adneto.in/product/bankco';
		}
	}, [isMainDomain]);

	return null;
};

export const formatAmount = (amount) => {
	return new Intl.NumberFormat('en-IN', {
		style: 'decimal',
		maximumFractionDigits: 2
	}).format(amount);
};

// Function to format numbers to Indian currency format
export const formatIndianNumber = (num) => {
	return new Intl.NumberFormat('en-IN', {
		maximumFractionDigits: 2,
		style: 'decimal'
	}).format(num);
};

export const formatDiscountRoundOff = (discount) => {
	const rounded = Number(discount).toFixed(2);
	return rounded.endsWith('.00') ? parseInt(rounded) : parseFloat(rounded);
};

// Date Format Generate

// Array of month names
export const monthNames = ["January", "February", "March", "April", "May", "June",
	"July", "August", "September", "October", "November", "December"
];

// Function to add ordinal suffix to day
export function getOrdinalSuffix(day) {
	if (day > 3 && day < 21) return 'th';
	switch (day % 10) {
		case 1: return "st";
		case 2: return "nd";
		case 3: return "rd";
		default: return "th";
	}
}

export const colorDetect = (status) => {
	if (status === "REFUNDED") {
		return {
			text: "Rejected",
			color: "#e53030",
		}
	} else if (status === "PENDING") {
		return {
			text: "Pending",
			color: "#ffbe41",
		}
	} else if (status === "PROCESSING") {
		return {
			text: "Pending",
			color: "#ffbe41",
		}
	} else if (status === "COMPLETED") {
		return {
			text: "Completed",
			color: "#6dc965",
		}
	} else {
		return {
			text: "Not Available",
			color: "#D9D9D9",
		}
	}
}

// Lighten the color
export const hexToRgb = (hex) => {
	// Remove the hash (#) if present
	const cleanHex = hex?.replace("#", "");
	// Split into R, G, B components
	const bigint = parseInt(cleanHex, 16);
	return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
};

// Darken the color
// Utility function to darken a hex color
export const darkenColor = (hex, amount = 20) => {
	let color = hex.replace("#", "");
	if (color.length === 3) {
		color = color.split("").map((char) => char + char).join("");
	}
	const r = Math.max(0, Math.min(255, parseInt(color.substring(0, 2), 16) - amount));
	const g = Math.max(0, Math.min(255, parseInt(color.substring(2, 4), 16) - amount));
	const b = Math.max(0, Math.min(255, parseInt(color.substring(4, 6), 16) - amount));
	return `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
};

export const newTheme = {
	bank: {
		hex_code: "f5437f",
		text_hex_code: "ffffff",
		logo: null
	},
	website_font_family: "Inter",
	website_font_url: "https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap"
}
// change in the header component to change intogrator

// Common function for integrator theme color of text and background
export function backgroundColor(theme = newTheme) {
	return theme?.bank?.hex_code ? `#${theme?.bank?.hex_code}` : theme?.brand?.hex_code ? `#${theme?.brand?.hex_code}` : "#F5437E";
}

export function textColor(theme = newTheme) {
	return theme?.bank?.text_hex_code ? `#${theme?.bank?.text_hex_code}` : theme?.brand?.text_hex_code ? `#${theme?.brand?.text_hex_code}` : "#FFFFFF";
}

export function defaultTextColor(theme = newTheme) {
	return theme?.bank?.hex_code ? `#${theme?.bank?.hex_code}` : theme?.brand?.hex_code ? `#${theme?.brand?.hex_code}` : "#F5437E";
}

const SubscriptionColor = {
	Offer: "#F5437E",
	Active: "#0AA910",
	Expiring: "#F58220",
	Expired: "#fa0e00"
}

// subscription related functions 
export function subscritptionDefaultColor(text) {
	return SubscriptionColor[text] || "#F5437E"
}

export const getSubscriptionBySlug = (subscriptionData, slug) => {
	// Return first item if array is empty or no slug provided
	if (!subscriptionData?.length || !slug) {
		return subscriptionData[0];
	}

	// Find subscription matching the slug
	const matchedSubscription = subscriptionData.find(
		subscription => subscription.slug === slug
	);

	// Return matched subscription or first item as fallback
	return matchedSubscription || subscriptionData[0];
};

// subscription data 
export const getStatusColor = (status) => {
	switch (status.toLowerCase()) {
		case 'paid':
			return 'border-[#58C3A8] text-[#58C3A8] px-5 py-2 border-2';
		case 'pending':
			return 'border-[#EFAF2D] text-[#EFAF2D] px-5 py-2 border-2';
		case 'failed':
			return 'border-[#E62929] text-[#E62929] px-5 py-2 border-2';
		default:
			return 'border-gray-600 text-gray-600 px-5 py-2 border-2';
	}
};

export const stopDetails = {
	1: { label: "Non Stop", color: "green" },
	2: { label: "1 Stop", color: "orange" },
	3: { label: "2+ Stops", color: "red" },
};

export function isPublicPage() {
	// Get the current URL path
	const currentPath = window.location.pathname;

	// Remove leading and trailing slashes for consistent comparison
	const normalizedPath = currentPath?.replace(/^\/|\/$/g, '');

	// Define patterns for public reward pages
	const publicRewardPatterns = [
		/^rewards\/[^/]+\/[^/]+\/[^/]+\/[^/]+$/, // Public reward detail page
		/^rewards\/[^/]+\/[^/]+$/, // Public reward listing page
		/^deals$/, // Public reward listing page
	];

	// Check if the path matches any public pattern
	return publicRewardPatterns?.some(pattern => pattern?.test(normalizedPath));
}

// * Generates a dynamic background image URL based on the screen size(mobile or desktop).
//  * Handles cases where the URL is null or invalid.
export const getDynamicBackgroundImageUrl = (url, isMobile) => {
	if (!url) {
		return ""; // Return empty string if the URL is null or undefined
	}

	try {
		// Only modify URL for mobile view
		if (isMobile) {
			// Case 1: Handle bg_image pattern URLs
			const bgImageParts = url.split("/bg_image/");
			if (bgImageParts.length === 2) {
				return `${bgImageParts[0]}/bg_image/mobile/${bgImageParts[1]}`;
			}

			// Case 2: Handle other URL patterns by inserting "mobile" before the last segment
			const urlObj = new URL(url);
			const pathParts = urlObj.pathname.split('/');

			// If there's at least one path segment
			if (pathParts.length > 1) {
				// Insert "mobile" before the last path segment
				pathParts.splice(pathParts.length - 1, 0, "mobile");

				// Reconstruct the URL
				urlObj.pathname = pathParts.join('/');
				return urlObj.toString();
			}
		}

		// Return the original URL if it's desktop view or if the URL structure is invalid
		return url;
	} catch (error) {
		console.error("Error generating background image URL:", error);
		return ""; // Return empty string in case of any error
	}
};

// Helper function to convert month abbreviation to month number
export const getMonthNumber = (monthAbbr) => {
	const months = {
		'Jan': 1, 'Feb': 2, 'Mar': 3, 'Apr': 4, 'May': 5, 'Jun': 6,
		'Jul': 7, 'Aug': 8, 'Sep': 9, 'Oct': 10, 'Nov': 11, 'Dec': 12
	};
	return months[monthAbbr] || 1;
};

// Helper function to get departure date and time as a timestamp
export const getDepartureDateTime = (flight, fromCityCode) => {
	if (!flight || !flight.Bonds || !flight.Bonds[0] || !flight.Bonds[0].Legs) {
		return 0; // Return default value if structure isn't as expected
	}

	// Find the leg where the Origin matches the fromCityCode
	const matchingLeg = flight.Bonds[0].Legs.find(leg => leg?.Origin === fromCityCode);

	if (matchingLeg) {
		// Parse departure date and time into a timestamp
		const dateStr = matchingLeg.DepartureDate;
		const timeStr = matchingLeg.DepartureTime;

		// Handle date format like "Wed-26Feb2025"
		const [_, day, monthYear] = dateStr.match(/(\d+)([A-Za-z]+)(\d+)/) || [];
		const month = getMonthNumber(monthYear.slice(0, 3));
		const year = monthYear.slice(3);

		// Parse time in 24-hour format like "21:20"
		const [hours, minutes] = timeStr.split(':').map(Number);

		const timestamp = new Date(year, month - 1, day, hours, minutes).getTime();
		return timestamp;
	} else {
		// If no match is found, use the first leg's departure time as fallback
		const firstLeg = flight.Bonds[0].Legs[0];
		const dateStr = firstLeg.DepartureDate;
		const timeStr = firstLeg.DepartureTime;

		// Handle date format like "Wed-26Feb2025"
		const [_, day, monthYear] = dateStr.match(/([A-Za-z]+)-(\d+)([A-Za-z]+)(\d+)/) || [];
		const month = getMonthNumber(monthYear.slice(0, 3));
		const year = monthYear.slice(3);

		// Parse time in 24-hour format like "21:20"
		const [hours, minutes] = timeStr.split(':').map(Number);

		const timestamp = new Date(year, month - 1, day, hours, minutes).getTime();
		return timestamp;
	}
}


// Add this new component to handle parameter extraction and redirection
export const PublicRewardRedirect = () => {
	localStorage.removeItem('rewardIntegratorId');
	localStorage.removeItem('rewardSubId');
	const { integratorId, subId } = useParams();
	const navigate = useNavigate();

	useEffect(() => {
		// Only run this once when the component mounts
		if (integratorId && subId) {
			// Save parameters to localStorage
			localStorage.setItem('rewardIntegratorId', integratorId);
			localStorage.setItem('rewardSubId', subId);

			// Redirect to public reward listing page (using navigate instead of Navigate component)
			navigate(`/${REWARD_LISTING}/${integratorId}/${subId}`, { replace: true });
		}
	}, [integratorId, subId, navigate]);

	// Return null or a loading indicator while redirecting
	return <Spinner />;
};

export function HighlightedText({ text, integratorTheme }) {
	// Match all text wrapped in #* and #* and split into parts
	const parts = text?.split(/(#\*.*?#\*)/)?.filter(Boolean);

	return (
		<div>
			{parts?.map((part, index) => {
				if (part?.startsWith("#*") && part?.endsWith("#*")) {
					// Remove the #* markers and wrap in span with highlight class
					const highlightedText = part?.slice(2, -2);

					return <span key={index} style={{ color: defaultTextColor(integratorTheme) }} className="font-semibold">{highlightedText}</span>;
				}

				// Render regular text
				return <span key={index}>{part}</span>;
			})}
		</div>
	);
};

// function to show loyalty points is available in module
export const showLoyaltyPoint = (theme) => {
	const baseModuleKeys = Object.keys(theme?.modules || {});
	const isLoyalityAvailable = baseModuleKeys?.includes("loyalty");
	return isLoyalityAvailable
}

// Component to render the offer title with dynamic placeholders and highlighted text
function OfferTitleRenderer({
	title, cardCount, integratorTheme, isMobile, renderDropDownHeader, renderDropDownBody, isOpenDrawer, setIsOpenDrawer, isPublic
}) {
	// Split title into parts for <<OFFER_COUNT>>, <<CARD>>, #*text#*, and regular text
	const parts = title?.split(/(<<OFFER_COUNT>>|<<CARD>>|#\*.*?#\*)/)?.filter(Boolean);

	return (
		<div className={`flex-wrap flex gap-1 md:gap-3`}>
			{parts?.map((part, index) => {
				if (part === '<<OFFER_COUNT>>') {
					// Render cardCount with integratorTheme background color
					return (
						<span
							key={index}
							style={{ color: !isMobile && backgroundColor(integratorTheme) }}
							className="flex items-center gap-2"
						>
							<ActiveRecordIcon
								width={isMobile ? 18 : 28}
								height={isMobile ? 18 : 28}
								style={{ fill: !isMobile && backgroundColor(integratorTheme) }}
								className="cardIcon"
							/>
							<span>{cardCount}</span>
						</span>
					);
				} else if (part === '<<CARD>>') {
					// Render Dropdown for desktop, nothing for mobile
					return !isMobile && (
						<div key={index} className="addCardDropdown">
							<Dropdown
								dropDownHeader={renderDropDownHeader}
								dropdownBody={renderDropDownBody}
								isShowIcon={true}
								isOpenDrawer={isOpenDrawer}
								setIsOpenDrawer={setIsOpenDrawer}
							/>
						</div>
					);
				} else if (part?.startsWith('#*') && part?.endsWith('#*')) {
					// Render highlighted text between #* and #*
					const highlightedText = part?.slice(2, -2);
					return (
						<span
							key={index}
							style={{ color: defaultTextColor(integratorTheme) }}
							className="font-semibold"
						>
							{highlightedText}
						</span>
					);
				} else {
					// Render regular text
					return <span key={index}>{part}</span>;
				}
			})}
		</div>
	);
}

// Updated renderCardInfo function
function renderCardInfo({
	cardCount, integratorTheme, isMobile, renderDropDownHeader, renderDropDownBody, isOpenDrawer, setIsOpenDrawer, offerTitle, isPublic
}) {
	return (
		<div
			className={`container px-5 mx-auto font-Inter cardInfo md:items-start text-base lg:text-2xl text-[#464646] flex gap-1 md:gap-3 mt-5`}
		>
			<OfferTitleRenderer
				title={offerTitle}
				cardCount={cardCount}
				integratorTheme={integratorTheme}
				isMobile={isMobile}
				renderDropDownHeader={renderDropDownHeader}
				renderDropDownBody={renderDropDownBody}
				isOpenDrawer={isOpenDrawer}
				setIsOpenDrawer={setIsOpenDrawer}
				isPublic={isPublic}
			/>
		</div>
	);
}

export { OfferTitleRenderer, renderCardInfo };

export const parseDuration = (durationStr) => {
	const match = durationStr.match(/(\d+)h\s*(\d+)?m?/); // Extract hours & minutes
	if (!match) return 0;

	const hours = parseInt(match[1] || "0", 10);
	const minutes = parseInt(match[2] || "0", 10);

	return hours * 60 + minutes; // Convert total duration to minutes
};

// Convert minutes to "HH:mm" format
export const formatMinutesToHHMM = (minutes) => {
	const hours = Math.floor(minutes / 60);
	const mins = minutes % 60;
	return `${String(hours).padStart(2, '0')}h ${String(mins).padStart(2, '0')}m`;
};


// Helper function to get DOB date range
export function getDOBDateRange(type, lastTravelDate) {
	const travelDate = dayjs(lastTravelDate || new Date());

	if (type === "adult") {
		// Adult: Must be at least 12 years old
		const maxDate = travelDate.subtract(12, 'year');
		return { minDate: null, maxDate };
	} else if (type === "child") {
		// Child: Between 2 and 12 years old
		const minDate = travelDate.subtract(12, 'year');
		const maxDate = travelDate.subtract(2, 'year');
		return { minDate, maxDate };
	} else if (type === "infant") {
		// Infant: Between 15 days and 2 years old
		const minDate = travelDate.subtract(2, 'year');
		const maxDate = travelDate.subtract(15, 'day');
		return { minDate, maxDate };
	}

	return { minDate: null, maxDate: null };
}

// travel form validation

// Helper function to check if DOB is valid
export function isValidDOB(dob, type, lastTravelDate) {
	if (!dob) return false;

	const birthDate = dayjs(dob);
	if (!birthDate.isValid()) return false;

	const travelDate = dayjs(lastTravelDate);

	if (type === "Adult") {
		return birthDate.isBefore(travelDate.subtract(12, 'year'));
	} else if (type === "Child") {
		return birthDate.isAfter(travelDate.subtract(12, 'year')) &&
			birthDate.isBefore(travelDate.subtract(2, 'year'));
	} else if (type === "Infant") {
		return birthDate.isAfter(travelDate.subtract(2, 'year')) &&
			birthDate.isBefore(travelDate.subtract(15, 'day'));
	}

	return false;
}

// Helper function to check passport expiry
export function isValidPassportExpiry(expiryDate, lastTravelDate) {
	if (!expiryDate) return false;

	const expiry = dayjs(expiryDate);
	if (!expiry.isValid()) return false;

	const sixMonthsAfterTravel = dayjs(lastTravelDate).add(6, 'month');
	return expiry.isAfter(sixMonthsAfterTravel);
}

// Traveller detail Validation functions
export const getTravellerDetailValidators = (type, lastTravelDate) => ({
	first_name: (value) => isValidString(value, true) ? "" : "First name is required and must contain only letters.",
	last_name: (value) => lastNamevalidation(value) ? "" : "Last name is required and must contain only letters.",
	email: (value) => value && !isValidEmail(value) ? "Invalid email address." : "",
	mobile_number: (value) => value && !isValidPhone(value) ? "Invalid phone number." : "",
	dob: (value) => {
		const isValid = isValidDOB(value, type, lastTravelDate);
		return !isValid ? (
			type === "Adult" ? "Age should be 12 years or older." :
				type === "Child" ? "Age should be between 2 to 12 years." :
					"Age should be between 15 days to 2 years."
		) : "";
	},
	passport: (value) => !value.trim() ? "Passport number is required." : "",
	passport_expiry: (value) => !isValidPassportExpiry(value, lastTravelDate) ?
		"Passport should be valid for at least 6 months from travel date." : "",
	frequent_flyer_number: (value) => value && !isAlphanumeric(value) ?
		"Only alphanumeric characters are allowed." : ""
});

// formst save traveller data
export const formatTravellerData = (formData, type) => {
	const { title, first_name, last_name, email, mobile_number, dob, passport, passport_expiry, frequent_flyer_airline, frequent_flyer_number, id } = formData;

	const traveller = {
		title,
		first_name,
		last_name,
		passenger_type: type?.charAt(0)?.toUpperCase() + type?.slice(1),
	};

	// Add optional fields if they are not empty
	if (id) traveller.id = id;
	if (email) traveller.email = email;
	if (mobile_number) traveller.mobile_number = mobile_number;
	if (dob) traveller.dob = dob;
	if (passport) traveller.passport = passport;
	if (passport_expiry) traveller.passport_expiry = passport_expiry;

	// Add frequent flyer details if both airline and number are provided
	if (frequent_flyer_airline && frequent_flyer_number) {
		traveller.frequent_flyer_details = {
			[frequent_flyer_airline]: frequent_flyer_number,
		};
	}

	return traveller;
};

// Enhanced validation functions
export const validateAllTravellers = (travellers, isInternational) => {
	const searchData = JSON.parse(fetchLocalStorageItem("flightSearchData") || "{}");

	// Ensure expectedCounts has default values if undefined
	const expectedCounts = {
		Adult: searchData?.travellers?.adults || 0,
		Child: searchData?.travellers?.children || 0,
		Infant: searchData?.travellers?.infants || 0
	};

	const actualCounts = travellers.reduce((acc, traveller) => {
		acc[traveller.passenger_type] = (acc[traveller.passenger_type] || 0) + 1;
		return acc;
	}, { Adult: 0, Child: 0, Infant: 0 });

	const countMismatchErrors = [];
	Object.keys(expectedCounts)?.forEach(type => {
		if (actualCounts[type] !== expectedCounts[type]) {
			countMismatchErrors.push({
				type,
				message: `Expected ${expectedCounts[type]} ${type}(s), but found ${actualCounts[type]}`
			});
		}
	});

	if (countMismatchErrors.length > 0) {
		setLocalStorageItem("travellerCountMismatch", JSON.stringify(countMismatchErrors));
		return true;
	} else {
		setLocalStorageItem("travellerCountMismatch", JSON.stringify([]));
	}

	const validationErrors = travellers.map((traveller, index) => ({
		passenger_type: traveller.passenger_type,
		original_index: traveller.originalIndex,
		errorFieldType: validateTraveller(traveller, isInternational)
	}));

	const hasFieldErrors = validationErrors.some(error => error.errorFieldType.length > 0);

	if (hasFieldErrors) {
		setLocalStorageItem("validationErrorState", JSON.stringify(validationErrors));
	} else {
		setLocalStorageItem("validationErrorState", JSON.stringify([]));
	}

	return hasFieldErrors;
};

export const validateTraveller = (traveller, isInternational) => {
	const errors = [];
	const requiredFields = {
		common: ['title', 'first_name', 'last_name'],
		infant: ['dob'],
		international: ['dob', 'passport_number', 'passport_expiry']
	};

	requiredFields.common?.forEach(field => {
		if (!traveller[field]) {
			errors.push({ type: field, message: `${field.replace('_', ' ')} is required` });
		}
	});

	if (traveller.passenger_type === 'Infant') {
		if (!traveller.dob) {
			errors.push({ type: 'dob', message: 'Date of birth is required for infants' });
		}
	}

	if (isInternational) {
		requiredFields.international?.forEach(field => {
			if (!traveller[field]) {
				errors.push({ type: field, message: `${field.replace('_', ' ')} is required for international travel` });
			}
		});
	}

	return errors;
};

// GST detail validaition function
export const getGSTDetailValidation = () => ({
	company_name: (value) =>
		value && !/^[a-zA-Z\s.]+$/.test(value)
			? "Company name must contain only letters, spaces, and dots."
			: !value
				? "Company name is required."
				: "",
	email: (value) => (!value ? "Email is required." : !isValidEmail(value) ? "Invalid email address." : ""),
	mobile_number: (value) => (!value ? "Mobile number is required." : !isValidPhone(value) ? "Invalid phone number." : ""),
	gstin: (value) => (!value ? "GST number is required." : !isValidGSTNumber(value) ? "Invalid GST number." : ""),
});

export const validateGSTDetail = (gstDetail) => {
	const errors = [];
	const requiredFields = ['gstin', 'company_name', 'email', 'mobile_number'];

	requiredFields.forEach(field => {
		if (!gstDetail[field]) {
			errors.push({ type: field, message: `${field.replace('_', ' ')} is required for GST` });
		}
	});

	return errors;
};

// Updated decode function to handle both URL params and login/signup data
export const decodeFlightSearchParams = (compressedParams) => {
	try {
		// If it's a string (URL param), decompress it first
		let minimized;
		if (typeof compressedParams === 'string') {
			const decompressed = LZString.decompressFromEncodedURIComponent(compressedParams);
			if (!decompressed) return null;
			minimized = JSON.parse(decompressed);
		} else {
			// If it's already an object (from login/signup), use it directly
			minimized = compressedParams;
		}

		// Reconstruct full data structure
		return {
			travellers: {
				adults: minimized.t.a,
				children: minimized.t.c,
				infants: minimized.t.i
			},
			fromAirport: typeof minimized.f === 'string'
				? { iata_code: minimized.f }
				: minimized.f, // Handle both IATA code string and full object
			toAirport: typeof minimized.to === 'string'
				? { iata_code: minimized.to }
				: minimized.to, // Handle both IATA code string and full object
			flightClass: minimized.cl === 'e' ? FLIGHT_CLASS_CONSTANT.ECONOMY :
				minimized.cl === 'p' ? FLIGHT_CLASS_CONSTANT.PREMIUM_ECONOMY :
					minimized.cl === 'b' ? FLIGHT_CLASS_CONSTANT.BUSINESS :
						FLIGHT_CLASS_CONSTANT.FIRST,
			departureDate: minimized.dd,
			returnDate: minimized.rd,
			isRoundTrip: minimized.rt === 1,
			oneWayTrip: minimized.rt === 0,
			selectedTripCategory: minimized.cat === 'r' ? FLIGHT_TRIP_CONSTANT.ROUNDTRIP :
				minimized.cat === 'o' ? FLIGHT_TRIP_CONSTANT.ONEWAY :
					FLIGHT_TRIP_CONSTANT.MULTICITY
		};
	} catch (error) {
		console.error('Error decoding flight search params:', error);
		return null;
	}
};

export const validateContactInfo = () => {
	const contactInfo = JSON.parse(fetchLocalStorageItem("contactInfo") || "{}");
	const { email = '', phoneNo = '' } = contactInfo;

	if (!email || !isValidEmail(email)) {
		return "Please provide a valid email address.";
	}
	if (!phoneNo || !isValidPhone(phoneNo)) {
		return "Please provide a valid phone number.";
	}
	return '';
};
